import { connect } from 'react-redux'
import CheckCardComponent from '../components/CheckCardComponent.jsx';
import {
	forwardToReloadCheckCard,
	forwardToFindCategories,
	forwardToSelectCategory,
	forwardToAddMaintenanceDetail,
	forwardToFindMaintenanceDetails,
	forwardToCompleteClothChecking,
	forwardToCompletePantChecking,
	forwardToRestoreClothChecking,
	forwardToRestorePantChecking,
	forwardToSetNote,
	forwardToResetCheckFileLink,
	forwardToShowDelCheckItemModal,
	forwardToShowPhotoBlk,
	forwardToHideDelCheckItemModal,
	forwardToHidePhotoBlk,
	forwardToSetRemoveItemType,
	forwardToRemoveMaintenanceDetail,
	forwardToCleanAlert,
	forwardToMarkCardAsDiscard,
	forwardToMarkAsNotDilivered,
	forwardToCancelNotDilivered,
	forwardToExpandMenuMax,
	forwardChangeIsLoadingPage,
	changeCheckCardPreviousPage
} from '../actions';

const mapStateToProps = (state) => ({
	alert: state.getIn(['checkCardReducer', 'alert']),
	view: state.getIn(['checkCardReducer', 'view']),
	request: state.getIn(['checkCardReducer', 'request']),
	isLoadingPage: state.getIn(['checkCardReducer', 'isLoadingPage']),

	previous: state.getIn(['maintenanceCardsReducer', 'mCardListRequestModel']),
	previousView: state.getIn(['maintenanceCardsReducer', 'mCardListViewModel']),
	cases: state.getIn(['maintenanceCasesReducer', 'mCaseListRequestModel']),
})

const mapDispatchToProps = (dispatch) => ({

	expandContent: () => {
		dispatch(forwardToExpandMenuMax());
	},

	// 衣服未送修
	markClothesAsNotDilivered: (cardPk, cardCode, operator) => {
		dispatch(forwardToMarkAsNotDilivered(cardPk, cardCode, "CLOTH", operator))
	},

	// 褲子未送修
	markPantAsNotDilivered: (cardPk, cardCode, operator) => {
		dispatch(forwardToMarkAsNotDilivered(cardPk, cardCode, "PANT", operator))
	},

	cancelClothesAsNotDilivered: (cardPk, cardCode, operator) => {
		dispatch(forwardToCancelNotDilivered(cardPk, cardCode, "CLOTH", operator))
	},

	cancelPantAsNotDilivered: (cardPk, cardCode, operator) => {
		dispatch(forwardToCancelNotDilivered(cardPk, cardCode, "PANT", operator))
	},

	// 建議衣服不再使用
	markClothesAsDiscard: (cardPk, cardCode, operator) => {
		dispatch(forwardToMarkCardAsDiscard(cardPk, cardCode, "CLOTH", operator))
	},

	// 建議褲子不再使用
	markPantAsDiscard: (cardPk, cardCode, operator) => {
		dispatch(forwardToMarkCardAsDiscard(cardPk, cardCode, "PANT", operator))
	},

	reloadCheckCard: (cardPk) => {
		dispatch(forwardToReloadCheckCard(cardPk))
	},

	addCheckDetail: (cardPk, epc, categoryPk, setPk, itemPk, note, operator) => {
		dispatch(forwardToAddMaintenanceDetail(cardPk, epc, categoryPk, setPk, itemPk, note, operator))
	},

	findCategories: () => {
		dispatch(forwardToFindCategories())
	},

	findDetails: (cardPk) => {
		dispatch(forwardToFindMaintenanceDetails(cardPk))
	},

	changeCategory: (index) => {
		dispatch(forwardToSelectCategory(index))
	},

	completeClothChecking: (cardPk, cardCode, operator) => {
		dispatch(forwardToCompleteClothChecking(cardPk, cardCode, operator))
	},
	completePantChecking: (cardPk, cardCode, operator) => {
		dispatch(forwardToCompletePantChecking(cardPk, cardCode, operator))
	},

	restoreClothChecking: (cardPk, cardCode, operator) => {
		dispatch(forwardToRestoreClothChecking(cardPk, cardCode, operator))
	},
	restorePantChecking: (cardPk, cardCode, operator) => {
		dispatch(forwardToRestorePantChecking(cardPk, cardCode, operator))
	},

	setNote: (id, value) => {
		dispatch(forwardToSetNote({
			param: id,
			value: value
		}))
	},

	resetCheckFileLink: (casePk) => {
		dispatch(forwardToResetCheckFileLink(casePk))
	},

	showModal: () => {
		dispatch(forwardToShowDelCheckItemModal())
	},

	showPhotoBlk: () => {
		dispatch(forwardToShowPhotoBlk())
	},

	hideModal: () => {
		dispatch(forwardToHideDelCheckItemModal())
	},

	hidePhotoBlk: () => {
		dispatch(forwardToHidePhotoBlk())
	},

	setRemoveItemType: (itemType) => {
		dispatch(forwardToSetRemoveItemType(itemType))
	},

	removeDetail: (detailPk, cardPk) => {
		dispatch(forwardToRemoveMaintenanceDetail(detailPk, cardPk));
	},

	cleanAlert: () => {
		dispatch(forwardToCleanAlert());
	},

	changeIsLoadingPage: (isLoading) => {
		dispatch(forwardChangeIsLoadingPage(isLoading));
	},

	changeCheckCardPreviousPage: (previousPage) => {
		dispatch(changeCheckCardPreviousPage(previousPage));
	}
})

const CheckCardContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(CheckCardComponent)

export default CheckCardContainer;


// WEBPACK FOOTER //
// ./src/containers/CheckCardContainer.jsx